/**
 * Constante des messages d'erreur
 */
export class ErrorMessageConstant {
	public static readonly DEFAULT_ERROR_MESSAGE = 'Une erreur inconnue est survenue';
	public static readonly FORBIDDEN_ERROR_MESSAGE = 'Vous n\'avez pas les droits pour effectuer cette action';
}
